// // // import React, { useState } from 'react';
// // // import { Link, useNavigate } from 'react-router-dom';
// // // import { Bars3Icon, XMarkIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
// // // import IsnartechLogo from '../assets/newlogoisnar.png'; // Update path as needed

// // // const Navbar = () => {
// // //   const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
// // //   const [isLoginDropdownOpen, setLoginDropdownOpen] = useState(false);

// // //   const navigate = useNavigate();

// // //   const handleNavigateLogin = (userType) => {
// // //     if (userType === 'admin') {
// // //       navigate('/adminstratorLogin');
// // //     } else {
// // //       navigate('/loginPage');
// // //     }
// // //     setLoginDropdownOpen(false);
// // //     setMobileMenuOpen(false);
// // //   };

// // //   return (
// // //     <header className="sticky top-0 z-50 backdrop-blur bg-gradient-to-r from-[#1f2937]/90 via-[#0f172a]/90 to-[#1f2937]/90 border-b border-slate-700 shadow-md">
// // //       <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // //         <div className="flex justify-between items-center h-16 text-white">

// // //           {/* Logo */}
// // //           <Link to="/" className="flex items-center gap-2">
// // //             <img src={IsnartechLogo} alt="Isnartech Logo" className="w-28 h-auto invert" />
// // //           </Link>

// // //           {/* Desktop Menu */}
// // //           <div className="hidden md:flex space-x-8 items-center">
// // //             <Link to="/" className="hover:text-indigo-400 transition">Home</Link>
// // //             <Link to="/about" className="hover:text-indigo-400 transition">About Us</Link>
// // //             <Link to="/contactForm" className="hover:text-indigo-400 transition">Contact</Link>
// // //             <Link to="/facility" className="hover:text-indigo-400 transition">Facility</Link>

           
// // //           </div>
// // //           {/* Mobile Toggle Button */}
// // //           <div className="md:hidden flex items-center">
// // //             <button onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}>
// // //               {isMobileMenuOpen ? (
// // //                 <XMarkIcon className="h-6 w-6" />
// // //               ) : (
// // //                 <Bars3Icon className="h-6 w-6" />
// // //               )}
// // //             </button>
// // //           </div>
// // //         </div>
// // //       </nav>

// // //       {/* Mobile Menu */}
// // //       {isMobileMenuOpen && (
// // //         <div className="md:hidden px-4 pb-4">
// // //           <Link to="/" className="block py-2 hover:text-indigo-400" onClick={() => setMobileMenuOpen(false)}>Home</Link>
// // //           <Link to="/about" className="block py-2 hover:text-indigo-400" onClick={() => setMobileMenuOpen(false)}>About Us</Link>
// // //           <Link to="/contactForm" className="block py-2 hover:text-indigo-400" onClick={() => setMobileMenuOpen(false)}>Contact</Link>
// // //           <Link to="/facility" className="block py-2 hover:text-indigo-400" onClick={() => setMobileMenuOpen(false)}>Facility</Link>

// // //           {/* Mobile Login Dropdown */}
// // //           <div className="mt-2">
// // //             <button
// // //               onClick={() => setLoginDropdownOpen(!isLoginDropdownOpen)}
// // //               className="flex items-center gap-1 hover:text-indigo-400 w-full"
// // //             >
// // //               Login
// // //               <ChevronDownIcon className="h-4 w-4" />
// // //             </button>
// // //             {isLoginDropdownOpen && (
// // //               <div className="mt-2 ml-4 space-y-1">
// // //                 <button
// // //                   className="block text-left text-white hover:text-indigo-300"
// // //                   onClick={() => handleNavigateLogin('user')}
// // //                 >
// // //                   Login as User
// // //                 </button>
// // //                 <button
// // //                   className="block text-left text-white hover:text-indigo-300"
// // //                   onClick={() => handleNavigateLogin('admin')}
// // //                 >
// // //                   Login as Administrator
// // //                 </button>
// // //               </div>
// // //             )}
// // //           </div>
// // //         </div>
// // //       )}
// // //     </header>
// // //   );
// // // };

// // // export default Navbar;


// // import React, { useEffect, useState } from 'react';
// // import { Link } from 'react-router-dom';
// // import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
// // import EduvantraLogo from '../assets/eduvantra.png'; // update path as needed

// // const links = [
// //   { to: '/', label: 'Home' },
// //   { to: '/about', label: 'About us' },
// //   { to: '/facility', label: 'Facility' },
// //   { to: '/contactForm', label: 'Contact' },
// // ];

// // const Navbar = () => {
// //   const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
// //   const [scrolled, setScrolled] = useState(false);

// //   useEffect(() => {
// //     const onScroll = () => setScrolled(window.scrollY > 8);
// //     window.addEventListener('scroll', onScroll);
// //     return () => window.removeEventListener('scroll', onScroll);
// //   }, []);

// //   return (
// //     <header
// //       className={`sticky top-0 z-50 bg-white/90 backdrop-blur transition-shadow duration-300 ${
// //         scrolled ? 'shadow-[0_1px_0_0_#E3E8F0,0_8px_24px_-16px_rgba(16,24,38,0.25)]' : 'shadow-none'
// //       } border-b border-[#E3E8F0]`}
// //     >
// //       <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //         <div className="flex justify-between items-center h-18 py-3">
// //           <Link to="/" className="flex items-center gap-2 shrink-0">
// //             <img src={EduvantraLogo} alt="Eduvantra" className="h-11 w-auto" />
// //           </Link>

// //           <div className="hidden md:flex items-center gap-9">
// //             {links.map((l) => (
// //               <Link
// //                 key={l.to}
// //                 to={l.to}
// //                 className="relative text-[#101826] font-['Sora',sans-serif] text-[15px] font-medium py-1 group"
// //               >
// //                 {l.label}
// //                 <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-[#E8A63C] transition-all duration-300 group-hover:w-full" />
// //               </Link>
// //             ))}
// //             <Link
// //               to="/registerSchool"
// //               className="ml-2 inline-flex items-center rounded-full bg-[#163863] px-6 py-2.5 font-['Sora',sans-serif] text-sm font-semibold text-white transition-colors duration-200 hover:bg-[#2E63B8]"
// //             >
// //               Register your school
// //             </Link>
// //           </div>

// //           <button
// //             className="md:hidden text-[#101826]"
// //             onClick={() => setMobileMenuOpen((v) => !v)}
// //             aria-label="Toggle menu"
// //           >
// //             {isMobileMenuOpen ? <XMarkIcon className="h-6 w-6" /> : <Bars3Icon className="h-6 w-6" />}
// //           </button>
// //         </div>
// //       </nav>

// //       {isMobileMenuOpen && (
// //         <div className="md:hidden px-4 pb-5 border-t border-[#E3E8F0] bg-white">
// //           {links.map((l) => (
// //             <Link
// //               key={l.to}
// //               to={l.to}
// //               className="block py-2.5 font-['Sora',sans-serif] text-[#101826] font-medium"
// //               onClick={() => setMobileMenuOpen(false)}
// //             >
// //               {l.label}
// //             </Link>
// //           ))}
// //           <Link
// //             to="/registerSchool"
// //             className="mt-2 block text-center rounded-full bg-[#163863] px-6 py-2.5 font-['Sora',sans-serif] text-sm font-semibold text-white"
// //             onClick={() => setMobileMenuOpen(false)}
// //           >
// //             Register your school
// //           </Link>
// //         </div>
// //       )}
// //     </header>
// //   );
// // };

// // export default Navbar;

// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
// import EduvantraLogo from '../assets/eduvantra.png'; // update path as needed

// const links = [
//   { to: '/', label: 'Home' },
//   { to: '/about', label: 'About us' },
//   { to: '/facility', label: 'Facility' },
//   { to: '/contactForm', label: 'Contact' },
// ];

// const Navbar = () => {
//   const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const onScroll = () => setScrolled(window.scrollY > 12);
//     onScroll();
//     window.addEventListener('scroll', onScroll);
//     return () => window.removeEventListener('scroll', onScroll);
//   }, []);

//   return (
//     <header
//       className={`fixed top-0 left-0 right-0 z-50 h-[76px] w-full backdrop-blur-xl transition-all duration-300 ${
//         scrolled
//           ? 'bg-white/85 border-b border-[#E3E8F0] shadow-[0_8px_24px_-16px_rgba(16,24,38,0.25)]'
//           : 'bg-white/45 border-b border-white/40'
//       }`}
//     >
//       <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
//         <div className="flex justify-between items-center h-full">
//           <Link to="/" className="flex items-center gap-2 shrink-0">
//             <img src={EduvantraLogo} alt="Eduvantra" className="h-11 w-auto" />
//           </Link>

//           <div className="hidden md:flex items-center gap-9">
//             {links.map((l) => (
//               <Link
//                 key={l.to}
//                 to={l.to}
//                 className="relative text-[#101826] font-['Sora',sans-serif] text-[15px] font-medium py-1 group"
//               >
//                 {l.label}
//                 <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-[#E8A63C] transition-all duration-300 group-hover:w-full" />
//               </Link>
//             ))}
//             <Link
//               to="/registerSchool"
//               className="ml-2 inline-flex items-center rounded-full bg-[#163863] px-6 py-2.5 font-['Sora',sans-serif] text-sm font-semibold text-white transition-colors duration-200 hover:bg-[#2E63B8]"
//             >
//               Register your school
//             </Link>
//           </div>

//           <button
//             className="md:hidden text-[#101826]"
//             onClick={() => setMobileMenuOpen((v) => !v)}
//             aria-label="Toggle menu"
//           >
//             {isMobileMenuOpen ? <XMarkIcon className="h-6 w-6" /> : <Bars3Icon className="h-6 w-6" />}
//           </button>
//         </div>
//       </nav>

//       {isMobileMenuOpen && (
//         <div className="md:hidden absolute top-[76px] left-0 right-0 px-4 pb-5 pt-2 border-t border-[#E3E8F0] bg-white shadow-lg">
//           {links.map((l) => (
//             <Link
//               key={l.to}
//               to={l.to}
//               className="block py-2.5 font-['Sora',sans-serif] text-[#101826] font-medium"
//               onClick={() => setMobileMenuOpen(false)}
//             >
//               {l.label}
//             </Link>
//           ))}
//           <Link
//             to="/registerSchool"
//             className="mt-2 block text-center rounded-full bg-[#163863] px-6 py-2.5 font-['Sora',sans-serif] text-sm font-semibold text-white"
//             onClick={() => setMobileMenuOpen(false)}
//           >
//             Register your school
//           </Link>
//         </div>
//       )}
//     </header>
//   );
// };

// export default Navbar;


import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import EduvantraLogo from '../assets/eduvantra.png'; // update path as needed

const links = [
  { to: '/', label: 'Home' },
  { to: '/#about', label: 'About us' },
  { to: '/#facility', label: 'Facility' },
  { to: '/contactForm', label: 'Contact' },
];

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 h-[72px] w-full backdrop-blur-xl transition-all duration-300 ${
        scrolled
          ? 'bg-white/85 border-b border-[#E3E8F0] shadow-[0_8px_24px_-16px_rgba(16,24,38,0.25)]'
          : 'bg-white/45 border-b border-white/40'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="flex justify-between items-center h-full">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <img src={EduvantraLogo} alt="Eduvantra" className="h-14 w-auto" />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="relative text-[#101826] text-[15px] font-medium py-1 group"
                style={{ fontFamily: "'Sora', sans-serif" }}
              >
                {l.label}
                <span className="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-[#E8A63C] transition-all duration-300 group-hover:w-full" />
              </Link>
            ))}

            {/* Second "find your school" entry point, at the top of the page */}
            <Link
              to="/#find-school"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#163863] border border-[#D8DEE9] rounded-full px-4 py-1.5 hover:border-[#2E63B8] hover:text-[#2E63B8] transition-colors duration-200"
              style={{ fontFamily: "'Sora', sans-serif" }}
            >
              <MagnifyingGlassIcon className="h-4 w-4" />
              Find your school
            </Link>

            <Link
              to="/registerSchool"
              className="inline-flex items-center rounded-full bg-[#163863] px-5 py-2 text-sm font-semibold text-white transition-colors duration-200 hover:bg-[#2E63B8]"
              style={{ fontFamily: "'Sora', sans-serif" }}
            >
              Register your school
            </Link>
          </div>

          <button
            className="md:hidden text-[#101826]"
            onClick={() => setMobileMenuOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <XMarkIcon className="h-6 w-6" /> : <Bars3Icon className="h-6 w-6" />}
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div
          className="md:hidden absolute top-[72px] left-0 right-0 px-4 pb-5 pt-2 border-t border-[#E3E8F0] bg-white shadow-lg"
          style={{ fontFamily: "'Sora', sans-serif" }}
        >
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="block py-2.5 text-[#101826] font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/#find-school"
            className="flex items-center gap-1.5 py-2.5 text-[#163863] font-semibold"
            onClick={() => setMobileMenuOpen(false)}
          >
            <MagnifyingGlassIcon className="h-4 w-4" />
            Find your school
          </Link>
          <Link
            to="/registerSchool"
            className="mt-2 block text-center rounded-full bg-[#163863] px-5 py-2.5 text-sm font-semibold text-white"
            onClick={() => setMobileMenuOpen(false)}
          >
            Register your school
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;

